var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3307 5.99833C11.3307 9.99833 5.9974 13.9983 5.9974 13.9983C5.9974 13.9983 0.664062 9.99833 0.664062 5.99833C0.664062 4.58384 1.22597 3.22728 2.22616 2.22709C3.22635 1.2269 4.58291 0.664993 5.9974 0.664993C7.41188 0.664993 8.76844 1.2269 9.76863 2.22709C10.7688 3.22728 11.3307 4.58384 11.3307 5.99833Z",
    stroke: "#18181B",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9974 7.99833C7.10197 7.99833 7.9974 7.1029 7.9974 5.99833C7.9974 4.89376 7.10197 3.99833 5.9974 3.99833C4.89283 3.99833 3.9974 4.89376 3.9974 5.99833C3.9974 7.1029 4.89283 7.99833 5.9974 7.99833Z",
    stroke: "#18181B",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.dd9566c11a0304a1d06148d9ee0f546d.svg";
export { ForwardRef as ReactComponent };